import { useState, useContext } from 'react'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import moment from 'moment'

const useDetalhesAgendamento = () => {
  const { sttCtxAgend, actionsAgend } = useContext(AgendamentoContext)
  const { userUCtx } = useContext(UsuarioContext)
  const [semAcesso, setSemAcesso] = useState(false)

  async function buscarPedido(idpedido) {
    const pedido = await actionsAgend.BuscarPedidoId(idpedido)
    return pedido
  }

  function verificarAcessoUsuario(pedido) {
    if (pedido.usuario.idusuario !== userUCtx.usuario.idusuario) return setSemAcesso(true)
    else return setSemAcesso(false)
  }

  function isLimiteReagendamentoExcedido() {
    const reagendamentos = sttCtxAgend.pedido.reagendamentos || []
    const userReschedulesCount = reagendamentos.filter(
      r => r.reagendadoPor === userUCtx.usuario.idusuario,
    ).length
    const userReschedulesLimit = userReschedulesCount >= 2
    return userReschedulesLimit
  }

  function checarRegraCancelamento() {
    const minutosAntecedencia = sttCtxAgend.pedido.regraCancelamento?.minutosAntecedencia || 0
    const podeReagendar =
      moment(sttCtxAgend.pedido.dataInicio).diff(moment(), 'minutes') >= minutosAntecedencia
    return podeReagendar
  }

  return {
    verificarAcessoUsuario,
    buscarPedido,
    isLimiteReagendamentoExcedido,
    checarRegraCancelamento,
    semAcesso,
  }
}

export default useDetalhesAgendamento
